import { render, staticRenderFns } from "./PeopleTimesheetInfo.vue?vue&type=template&id=2ffacf91&scoped=true&"
import script from "./PeopleTimesheetInfo.vue?vue&type=script&lang=js&"
export * from "./PeopleTimesheetInfo.vue?vue&type=script&lang=js&"
import style0 from "./PeopleTimesheetInfo.vue?vue&type=style&index=0&id=2ffacf91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffacf91",
  null
  
)

export default component.exports